module.exports = __webpack_public_path__ + "img/lead_slide4_md.bd6fcc8e.png";